<template>
  <div class="message-create">
    <header-top showBack></header-top>
    <div class="header-title show-back">添加系统消息</div>
    <div class="message-create-main">
      <el-form
        label-position="left"
        label-width="6rem"
        ref="messageForm"
        :rules="messageRules"
        :model="messageForm"
      >
        <div class="create-item">
          <div class="create-item-title">基础信息</div>
          <div class="create-item-main">
            <div class="flex-items">
              <div class="flex-item">
                <el-form-item label="标题" prop="title">
                  <el-input
                    v-model="messageForm.title"
                    placeholder="请输入标题"
                    clearable
                  ></el-input>
                </el-form-item>
               
              </div>
            </div>
            <el-form-item label="正文" class="auto-height margin-right">
              <el-input
                type="textarea"
                v-model="messageForm.content"
                placeholder="请输入正文"
                show-word-limit
                resize="none"
              ></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <div class="create-btns">
        <el-button @click="cancel">取 消</el-button>
        <el-button
          type="primary"
          @click="submitMessageForm"
          :loading="isLoading"
          >保 存</el-button
        >
      </div>
    </div>
 
  </div>
</template>

<script>
import headerTop from "@/components/HeaderTop";
import {addMessage} from "@/http/api/message"
export default {
  components: {
    headerTop,
  },
  data() {
    
    return {
     
      messageForm: {
        title: "",
        content:"",
      },
      isLoading:false,

      messageRules: {
        title: [
          {
            required: true,
            trigger: "blur",
            message: "请输入标题",
          },
        ],
      },
      
    };
  },
  methods: {
   
    // 提交客源表单
    submitMessageForm() {
      this.$refs["messageForm"].validate((valid) => {
        if (valid) {
          this.isLoading = true;
            addMessage(this.messageForm)
              .then((res) => {
                if (res) {
                  this.$message.success({
                    message: "保存成功",
                    showClose: true,
                  });
                  this.$router.push({ name: "messageList" });
                }
                this.isLoading = false;
              })
              .catch(() => {
                this.isLoading = false;
              });
         
        } else {
          //console.log("表单验证未通过");
          return false;
        }
      });
    },
    // 取消返回
    cancel() {
      this.$confirm(`您确定不保留数据回到列表页吗？`, "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$router.push({ name: "messageList" });
        })
        .catch(() => {
          //console.log("已取消");
        });
    },
    
  },
  mounted() {

  },
};
</script>

<style lang="scss" scoped>
.message-create {
  .message-create-main {
    padding: 20px;

    .create-item {
      margin-bottom: 20px;
      border-radius: $--border-radius-base;
      background: #ffffff;

      .create-item-title {
        display: flex;
        align-items: center;
        justify-content: space-between;

        padding: 20px;
        border-bottom: 1px solid #e0e0e0;

        font-size: 16px;
        font-weight: bold;
        color: #7d7d7d;
      }

      .create-item-main {
        padding: 20px;

        .el-input {
          width: 330px;
        }
        
        .margin-right {
          margin-right: 80px;
        
        }

        .el-textarea {
            width: 330px;
          ::v-deep .el-textarea__inner {
            height: 87px;
          }
        }
      }
    }
  }

  .flex-items {
    display: flex;
    .flex-item {
      width: 50%;
    }
  }

  .create-btns {
    border-radius: $--border-radius-base;
    padding: 20px;
    text-align: center;
    background: #fff;

    .el-button {
      width: 140px;
    }
  }
}
</style>